import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { PersonalCreditReport } from 'app/models/dto/credit-reports/personal-credit-report.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';

@Injectable()
export class CreditReportsService {

  constructor(
    private http: ApiHttpClient,
    private store: Store
  ) { }

  getPersonalCreditReport(borrowerId?: number | null): Observable<PersonalCreditReport> {
    return this.http.get<PersonalCreditReport>(`${environment.API_URL}/experian/credit-report/borrower/${borrowerId}`);
  }

}
